export default "__VITE_ASSET__6017cefb__"